<style lang="less" scoped>
.margin-tb {
  height: 32px;
  margin-top: 4px;
}

.query-title-div {
  width: 90px !important;
}
.topList {
  height: 175px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .topList-div {
    width: 30%;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #4182eb;
    border-radius: 22px;
    div {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      &:first-child {
        width: 35%;
        padding: 10px;
        // text-align: center;
        height: 80%;
        color: white;
        font-weight: 600;
        p:nth-child(1) {
          width: 38px;
          height: 38px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        p:nth-child(3) {
          font-size: 23px;
        }
      }
      &:last-child {
        flex: 1;
        height: 80%;
        border-left: 1px solid rgba(255, 255, 255, 0.404);
        color: white;
        p {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 10px;
          box-sizing: border-box;
        }
      }
    }
  }
  .topList-div3 {
    width: 30%;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #4182eb;
    border-radius: 22px;
    div {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;
      // text-align: center;
      &:first-child {
        width: 50%;
        padding: 10px;
        // text-align: center;
        height: 80%;
        color: white;
        font-weight: 600;
        border-right: 1px solid rgba(255, 255, 255, 0.404);
        padding: 20px;
        box-sizing: border-box;
        p:nth-child(1) {
          width: 38px;
          height: 38px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        p:nth-child(3) {
          font-size: 23px;
        }
      }
      &:last-child {
        width: 50%;
        padding: 10px;
        // text-align: center;
        height: 80%;
        color: white;
        font-weight: 600;
        padding: 20px;
        box-sizing: border-box;
        p:nth-child(1) {
          width: 38px;
          height: 38px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        p:nth-child(3) {
          font-size: 23px;
        }
      }
    }
  }
}
.reportDiv {
  width: 100%;
  height: 600px;
  overflow: auto;
  // padding: 20px;
  border: 1px solid #e6e8ef;
  margin-top: 20px;
  border-radius: 7px;
  .reportDiv-List {
    width: 100%;
    padding: 20px;
    .list {
      display: flex;
      justify-content: space-between;
      align-content: center;
      .list-left {
        width: 38%;
        border: 1px solid #e6e8ef;
        border-radius: 14px;
        height: 343px;
        overflow: hidden;
        div:last-child {
          p {
            display: flex;
            justify-content: space-around;
            align-items: center;
            font-size: 16px;
            height: 16px;
            line-height: 16px;
            margin: 30px 0;
            span:nth-child(1) {
              display: block;
              width: 40%;
            }
            span:nth-child(2) {
              display: block;
              width: 20%;
            }
            span:nth-child(3) {
              display: block;
              width: 20%;
            }
          }
        }
      }
      .list-right {
        width: 60%;
        height: 343px;
        border: 1px solid #e6e8ef;
        border-radius: 14px;
        overflow: hidden;
        .registration-trends {
          width: 100%;
          height: 257px;
        }
      }
    }
  }
}
.reportDiv-List3 {
  width: 100%;
  padding: 20px;
  .list {
    display: flex;
    justify-content: space-between;
    align-content: center;
    .list-left {
      width: 48%;
      border: 1px solid #e6e8ef;
      border-radius: 14px;
      height: 343px;
      overflow: hidden;
      .registration-trends {
        width: 100%;
        height: 257px;
      }
    }
    .list-right {
      width: 48%;
      height: 343px;
      border: 1px solid #e6e8ef;
      border-radius: 14px;
      overflow: hidden;
      .registration-trends {
        width: 100%;
        height: 257px;
      }
    }
  }
}

.blue {
  background: #4182eb !important;
  color: white !important;
  border: none;
}
.gray {
  background: #e7e7e8 !important;
  border: none;
  color: #9ba5ba;
  // color: white !important;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title">运营数据概览</div>
      <div class="topList">
        <div class="topList-div">
          <div>
            <p>
              <img src="../../../assets/operationalData/注册.png" alt="" />
            </p>
            <p>注册用户总数</p>
            <p>{{custRegistDto.registCountAll | numberToCurrency}}</p>
          </div>
          <div>
            <p>
              <span>挚达APP注册数</span>
              <span>{{custRegistDto.registCountZdApp| numberToCurrency}}</span>
            </p>
            <p>
              <span>桩到家APP注册数</span>
              <span>{{custRegistDto.registCountZdjApp| numberToCurrency}}</span>
            </p>
            <p>
              <span>支付宝小程序注册数</span>
              <span>{{custRegistDto.registCountZdAli| numberToCurrency}}</span>
            </p>
            <p>
              <span>微信小程序注册数</span>
              <span>{{custRegistDto.registCountZdWeChat| numberToCurrency}}</span>
            </p>
          </div>
        </div>
        <div class="topList-div">
          <div>
            <p>
              <img src="../../../assets/operationalData/绑定.png" alt="" />
            </p>
            <p>充电桩绑定数</p>
            <p>{{pileBindDto.bindCountAll| numberToCurrency}}</p>
          </div>
          <div>
            <p>
              <span>挚达APP绑定数</span>
              <span>{{pileBindDto.bindCountZdApp| numberToCurrency}}</span>
            </p>
            <p>
              <span>桩到家APP绑定数</span>
              <span>{{pileBindDto.bindCountZdjApp| numberToCurrency}}</span>
            </p>
            <p>
              <span>支付宝小程序绑定数</span>
              <span>{{pileBindDto.bindCountZdAli| numberToCurrency}}</span>
            </p>
            <p>
              <span>微信小程序绑定数</span>
              <span>{{pileBindDto.bindCountZdWeChat| numberToCurrency}}</span>
            </p>
          </div>
        </div>

        <div class="topList-div3">
          <div>
            <p>
              <img src="../../../assets/operationalData/绑定.png" alt="" />
            </p>
            <p>日活用户数</p>
            <p>{{ custActiveDto.dauAll | numberToCurrency}}</p>
          </div>
          <div>
            <p>
              <img src="../../../assets/operationalData/绑定.png" alt="" />
            </p>
            <p>月活用户数</p>
            <p>{{custActiveDto.mauAll | numberToCurrency}}</p>
          </div>
        </div>
      </div>
      <!-- 报表 -->
      <div class="reportDiv">
        <div class="topTitle">
          <div>{{statisDateAll}}</div>
          <div>
            <el-button
              :class="daysChange ? 'blue' : 'gray'"
              type="primary"
              @click="handleDateChange"
              round
              >近七天</el-button
            >
            <el-button
              :class="!daysChange ? 'blue' : 'gray'"
              type="primary"
              @click="handleDateChange"
              round
              >近三十天</el-button
            >
          </div>
        </div>
        <!-- 用户注册数 -->
        <div class="reportDiv-List">
          <div class="list">
            <div class="list-left">
              <div class="topTitle">
                <div>用户注册数</div>
                <div><span>{{detailInfo.custRegistDto.registCountAll | numberToCurrency}}</span></div>
              </div>
              <div>
                <p>
                  <span></span>
                  <span>数量</span>
                  <span>占比</span>
                </p>
                <p>
                  <span>挚达APP注册数</span>
                  <span>{{detailInfo.custRegistDto.registCountZdApp | numberToCurrency}}</span>
                  <span>{{detailInfo.custRegistDto.registRatioZdApp|numFilter}}%</span>
                </p>
                <p>
                  <span>桩到家APP注册数</span>
                  <span>{{detailInfo.custRegistDto.registCountZdjApp | numberToCurrency}}</span>
                  <span>{{detailInfo.custRegistDto.registRatioZdjApp |numFilter}}%</span>
                </p>
                <p>
                  <span>支付宝小程序注册数</span>
                  <span>{{detailInfo.custRegistDto.registCountZdAli | numberToCurrency}}</span>
                  <span>{{detailInfo.custRegistDto.registRatioZdAli |numFilter}}%</span>
                </p>
                <p>
                  <span>微信小程序注册数</span>
                  <span>{{detailInfo.custRegistDto.registCountZdWeChat | numberToCurrency}}</span>
                  <span>{{detailInfo.custRegistDto.registRatioZdWeChat |numFilter}}%</span>
                </p>
              </div>
            </div>
            <div class="list-right">
              <div class="topTitle">
                <div>用户注册趋势</div>
              </div>
              <div class="registration-trends" id="RegistrationTrends"></div>
            </div>
          </div>
        </div>
        <!-- 充电桩绑定数 -->
        <div class="reportDiv-List">
          <div class="list">
            <div class="list-left">
              <div class="topTitle">
                <div>充电桩绑定数</div>
                <div><span>{{detailInfo.pileBindDto.bindCountAll | numberToCurrency}}</span></div>
              </div>
              <div>
                <p>
                  <span></span>
                  <span>数量</span>
                  <span>占比</span>
                </p>
                <p>
                  <span>挚达APP绑定数</span>
                  <span>{{detailInfo.pileBindDto.bindCountZdApp | numberToCurrency}}</span>
                  <span>{{detailInfo.pileBindDto.bindRatioZdApp |numFilter}}%</span>
                </p>
                <p>
                  <span>桩到家APP绑定数</span>
                  <span>{{detailInfo.pileBindDto.bindCountZdjApp | numberToCurrency}}</span>
                  <span>{{detailInfo.pileBindDto.bindRatioZdjApp |numFilter}}%</span>
                </p>
                <p>
                  <span>支付宝小程序绑定数</span>
                  <span>{{detailInfo.pileBindDto.bindCountZdAli | numberToCurrency}}</span>
                  <span>{{detailInfo.pileBindDto.bindRatioZdAli |numFilter}}%</span>
                </p>
                <p>
                  <span>微信小程序绑定数</span>
                  <span>{{detailInfo.pileBindDto.bindCountZdWeChat | numberToCurrency}}</span>
                  <span>{{detailInfo.pileBindDto.bindRatioZdWeChat |numFilter}}%</span>
                </p>
              </div>
            </div>
            <div class="list-right">
              <div class="topTitle">
                <div>充电桩绑定趋势</div>
              </div>
              <div class="registration-trends" id="bindingTrend"></div>
            </div>
          </div>
        </div>
        <!-- 活跃用户数 -->
        <div class="reportDiv-List3">
          <div class="list">
            <div class="list-left">
              <div class="topTitle">
                <div>活跃用户数</div>
                <div><span>{{ detailInfo.custActiveDto.activeCountAll | numberToCurrency}}</span></div>
              </div>
              <div class="registration-trends" id="activeUsers"></div>
            </div>
            <div class="list-right">
              <div class="topTitle">
                <div>蚂蚁能量发放/g</div>
                <div><span>{{ detailInfo.greenEnergyDto.greenEnergyValue | numberToCurrency}}</span></div>
                <!-- <div><span>10</span></div> -->
              </div>
              <div class="registration-trends" id="antEnergy"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
import dateUtil from "../../../utils/dateUtils";
import { EleResize } from "../../../config/esresize";
import * as echarts from "echarts";
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      statisDateAll:'',
      daysChange: true,
      custActiveDto:{
        dauAll: "",
          mauAll: "",
          activeCountAll:''
      },
      custRegistDto:{
        activeCountAll:'',
          activeCountZdAli:'',
          activeCountZdApp:'',
          activeCountZdWeChat:'',
          activeCountZdjApp:'',
          activeRatioZdAli:'',
          activeRatioZdApp:'',
          activeRatioZdWeChat:'',
          activeRatioZdjApp:'',
          dauAll: '',
          mauAll: '',
          statisDate: "",
      },
      pileBindDto:{
        bindCountAll: '',
          bindCountZdAli: '',
          bindCountZdApp: '',
          bindCountZdWeChat: '',
          bindCountZdjApp: '',
          bindRatioZdAli:'',
          bindRatioZdApp:'',
          bindRatioZdWeChat:'',
          bindRatioZdjApp:'',
          statisDate: "",
      } ,
      detailInfo: {
        custActiveDto: {
          dauAll: "",
          mauAll: "",
          activeCountAll:''
        },
        greenEnergyDto: {
          greenEnergyValue:''
        },
        custRegistDto: {
          activeCountAll:'',
          activeCountZdAli:'',
          activeCountZdApp:'',
          activeCountZdWeChat:'',
          activeCountZdjApp:'',
          activeRatioZdAli:'',
          activeRatioZdApp:'',
          activeRatioZdWeChat:'',
          activeRatioZdjApp:'',
          dauAll: '',
          mauAll: '',
          statisDate: "",
        },
        pileBindDto: {
          bindCountAll: '',
          bindCountZdAli: '',
          bindCountZdApp: '',
          bindCountZdWeChat: '',
          bindCountZdjApp: '',
          bindRatioZdAli:'',
          bindRatioZdApp:'',
          bindRatioZdWeChat:'',
          bindRatioZdjApp:'',
          statisDate: "",
        },
        custRegistList:[],
        pileBindList:[],
        custActiveList:[],
        greenEnergyList:[]
      },
      // 用户注册日期,总数
      custRegistStatisDate:[],
      custRegistRegistCountAll:[],
      // 桩绑定日期，总数
      pileBindStatisDate:[],
      pileBindfield_12:[],
      // 活跃用户日期，总数
      custActiveListStatisDate:[],
      custActiveListActiveCountAll:[],
      // 蚂蚁能量日期，总数
      greenEnergyListStatisDate:[],
      greenEnergyListGreenEnergyValue:[]
    };
  },
  methods: {
    // 判断页面路由是否存在手机号码/站点编号
    init() {
      // 获取用户注册趋势
      // this.getRegistrationTrends();
    },
    //选择系统日期时间
    handleDateChange(val) {
      this.daysChange = !this.daysChange;
      
      this.getData()
      this.statisDateAll = `${this.startDate}~${this.endDate}`
    },

    //表格详情
    toDetail(val) {
      let _ = this;
      var url = _.$router.resolve({ name: "orderDetail", query: { id: val } });
      window.open(url.href, "_blank");
    },
    getWeek() {
      let time = new Date().getTime();
      let endTime = time - 6 * 24 * 3600 * 1000;
      this.startDate = this.$dayjs(endTime).format("YYYY-MM-DD");
      this.endDate = this.$dayjs(time).format("YYYY-MM-DD");
      console.log(this.startDate); // 开始时间
      console.log(this.endDate); // 结束时间
    },
    getMonth() {
      let time = new Date().getTime();
      let now = new Date(); // 当前日期
      let nowMonth = now.getMonth(); // 当前月
      let nowYear = now.getFullYear(); // 当前年
      let monthStartDate = new Date(nowYear, nowMonth, 1);
      let monthEndDate = new Date(nowYear, nowMonth + 1, 0);
      this.startDate = this.$dayjs(monthStartDate).format("YYYY-MM-DD");
      this.endDate = this.$dayjs(monthEndDate).format("YYYY-MM-DD");
    },
    getData() {
      let _ = this;
      if (this.daysChange) {
        this.getWeek();
      } else {
        this.getMonth();
      }
      let obj = {
        startDate: _.startDate,
        endDate: _.endDate,
      };
      _.custRegistStatisDate = []
      _.pileBindStatisDate = []
      _.custActiveListStatisDate = []
      _.greenEnergyListStatisDate = []
     
      _.$H.post(_, _.$A.operateStatis.overviewChart, obj).then((res) => {
        _.detailInfo = res.data.data;
        // 用户注册
        res.data.data.custRegistList.forEach(item=>{
          _.custRegistStatisDate.push(item.statisDate)
          _.custRegistRegistCountAll.push(item.registCountAll)
        })
        // 用户绑定
        res.data.data.pileBindList.forEach(item=>{
          _.pileBindStatisDate.push(item.statisDate)
          _.pileBindfield_12.push(item.bindCountAll)
        })
        // 活跃用户
        res.data.data.custActiveList.forEach(item=>{
          _.custActiveListStatisDate.push(item.statisDate)
          _.custActiveListActiveCountAll.push(item.activeCountAll)
        })
        // 蚂蚁能量
        res.data.data.greenEnergyList.forEach(item=>{
          _.greenEnergyListStatisDate.push(item.statisDate)
          _.greenEnergyListGreenEnergyValue.push(item.greenEnergyValue)
        })
        _.getRegistrationTrends()
        _.getBindingTrend()
        _.getActiveUsers()
        _.getAntEnergy()
      });
      _.$H.post(_, _.$A.operateStatis.countStatis, obj).then((res) => {
        _.custActiveDto = res.data.data.custActiveDto;
        _.custRegistDto = res.data.data.custRegistDto;
        _.pileBindDto = res.data.data.pileBindDto;
        
      });
    },
    // 注册趋势
    getRegistrationTrends() {
      // 基于准备好的dom，初始化echarts实例
      let changeChart = this.$echarts.init(
        document.getElementById("RegistrationTrends")
      );
      // 绘制图表
      changeChart.setOption({
        tooltip: {
          trigger: "axis",
          // backgroundColor:'transparent',
          axisPointer: {
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#f6eefd", // 0% 处的颜色
                  },
                  {
                    offset: 0.5,
                    color: "#dec8f5", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#cfabf7", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: false,
          },
          data: this.custRegistStatisDate,
        },
        yAxis: {
          type: "value",
          max: 1000, //最大值
          min: 0, //最小值
          interval: 500, //间隔

          //坐标轴最大值、最小值、强制设置数据的步长间隔
          // interval: 5,
          // axisLabel: {
          //     //y轴上带的单位
          //     formatter: '{value}'
          // },
          //轴线
          axisLine: {
            show: true,
          },
          // //分割线
          // splitLine: {
          //     show: false
          // }
        },
        series: [
          {
            data: this.custRegistRegistCountAll,
            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: "#bc88f5", //改变折线点的颜色
                lineStyle: {
                  color: "#bc88f5", //改变折线颜色
                },
              },
            },
          },
        ],
      });
      setTimeout(() => {
        window.addEventListener("resize", function() {
          changeChart.resize();
        });
      }, 500);
    },
    // 绑定趋势
    getBindingTrend() {
      // 基于准备好的dom，初始化echarts实例
      let changeChart = this.$echarts.init(
        document.getElementById("bindingTrend")
      );
      // 绘制图表
      changeChart.setOption({
        tooltip: {
          trigger: "axis",
          // backgroundColor:'transparent',
          axisPointer: {
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#e0ecff", // 0% 处的颜色
                  },
                  {
                    offset: 0.5,
                    color: "#d1e5ff", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#3f8fff", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: false,
          },
          data: this.pileBindStatisDate,
        },
        yAxis: {
          type: "value",
          max: 1000, //最大值
          min: 0, //最小值
          interval: 500, //间隔

          //坐标轴最大值、最小值、强制设置数据的步长间隔
          // interval: 5,
          // axisLabel: {
          //     //y轴上带的单位
          //     formatter: '{value}'
          // },
          //轴线
          axisLine: {
            show: true,
          },
          // //分割线
          // splitLine: {
          //     show: false
          // }
        },
        series: [
          {
            data: this.pileBindfield_12,
            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: "#408fff", //改变折线点的颜色
                lineStyle: {
                  color: "#408fff", //改变折线颜色
                },
              },
            },
          },
        ],
      });
      setTimeout(() => {
        window.addEventListener("resize", function() {
          changeChart.resize();
        });
      }, 500);
    },
    // 活跃用户
    getActiveUsers() {
      // 基于准备好的dom，初始化echarts实例
      let changeChart = this.$echarts.init(
        document.getElementById("activeUsers")
      );
      // 绘制图表
      changeChart.setOption({
        tooltip: {
          trigger: "axis",
          // backgroundColor:'transparent',
          axisPointer: {
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#ffdfdf", // 0% 处的颜色
                  },
                  {
                    offset: 0.5,
                    color: "#ffa4a4", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#ff8383", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: false,
          },
          data: this.custActiveListStatisDate,
        },
        yAxis: {
          type: "value",
          max: 1000, //最大值
          min: 0, //最小值
          interval: 500, //间隔

          //坐标轴最大值、最小值、强制设置数据的步长间隔
          // interval: 5,
          // axisLabel: {
          //     //y轴上带的单位
          //     formatter: '{value}'
          // },
          //轴线
          axisLine: {
            show: true,
          },
          // //分割线
          // splitLine: {
          //     show: false
          // }
        },
        series: [
          {
            data: this.custActiveListActiveCountAll,
            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: "#ff8383", //改变折线点的颜色
                lineStyle: {
                  color: "#ff8383", //改变折线颜色
                },
              },
            },
          },
        ],
      });
      setTimeout(() => {
        window.addEventListener("resize", function() {
          changeChart.resize();
        });
      }, 500);
    },
    // 蚂蚁能量
    getAntEnergy() {
      // 基于准备好的dom，初始化echarts实例
      let changeChart = this.$echarts.init(
        document.getElementById("antEnergy")
      );
      // 绘制图表
      changeChart.setOption({
        tooltip: {
          trigger: "axis",
          // backgroundColor:'transparent',
          axisPointer: {
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#ecfced", // 0% 处的颜色
                  },
                  {
                    offset: 0.5,
                    color: "#c5f7c6", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#19de1f", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: false,
          },
          data: this.greenEnergyListStatisDate,
        },
        yAxis: {
          type: "value",
          max: 1000, //最大值
          min: 0, //最小值
          interval: 500, //间隔

          //坐标轴最大值、最小值、强制设置数据的步长间隔
          // interval: 5,
          // axisLabel: {
          //     //y轴上带的单位
          //     formatter: '{value}'
          // },
          //轴线
          axisLine: {
            show: true,
          },
          // //分割线
          // splitLine: {
          //     show: false
          // }
        },
        series: [
          {
            data: this.greenEnergyListGreenEnergyValue,
            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: "#19de1f", //改变折线点的颜色
                lineStyle: {
                  color: "#19de1f", //改变折线颜色
                },
              },
            },
          },
        ],
      });
      setTimeout(() => {
        window.addEventListener("resize", function() {
          changeChart.resize();
        });
      }, 500);
    },

    // echarts 实例
    drawECharts(dom, option) {
      let myChart = this.$echarts.init(document.getElementById(dom));
      let resizeDiv = document.getElementById(dom);
      resizeDiv.removeAttribute("_echarts_instance_");
      // 绘制图表
      myChart.setOption(option);
      let listener = () => {
        myChart.resize();
      };
      EleResize.on(resizeDiv, listener);
    },
  },
  mounted() {
    this.init();
    this.getData();
    this.statisDateAll = `${this.startDate}~${this.endDate}`
    this.getRegistrationTrends();
    this.getBindingTrend();
    this.getActiveUsers();
    this.getAntEnergy();
  },
};
</script>
